module.exports = __webpack_public_path__ + "static/media/video-thumbnail.357231e7.webp";